export default __webpack_public_path__ + "static/rsz_cec_0001_002_-_copy-6b3c2270c42b36f79352fdf274f846b4.jpg";